<template>
  <div class="changeNameDialog">
    <Modal
      v-model="openConfirmDialog"
      class-name="confirm-modal"
      :footer-hide="true"
    >
      <div class="changeWarpper">
        <p class="title">
          Edit Name
        </p>
        <input v-model="newName" type="text">
        <div class="button-warpper">
          <button @click="onSave">
            Confirm
          </button>
          <!-- <button>Cancel</button> -->
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      openConfirmDialog: false,
      newName: "",
    };
  },
  methods: {
    open(data) {
      console.log("open");
      this.openConfirmDialog = true;
      this.newName = data;
    },
    onSave() {
      this.$parent.onChangeName(this.newName);
      this.openConfirmDialog = false;
    }
  },
};
</script>

<style lang="less" scoped>
.title {
  width: 100%;
  text-align: center;
  font-size: 24px;
  color: #fff;
}
input {
  width: 100%;
  outline: none;
  border-radius: 4px;
  font-size: 24px;
  background-color: #555d61;
  // border: 1px solid #fff;
  margin: 40px 0;
  color: #fff;
  padding: 10px;
}
.button-warpper {
  button {
    font-size: 16px;
    width: 100%;
    padding: 10px 0px;
    // height: 42px;
    border-radius: 6px;
    // border: 1px solid #ccc;
    background: #718892;
    color: #fff;
  }
}
</style>
